import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
    socket: {}
};

const socketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    setSocket(state, action: PayloadAction<any>) {
      state.socket = action?.payload
    },
    getSocket: (state) => {
      return state.socket // Reset user details
    }
  }
});

export const { setSocket, getSocket } = socketSlice.actions;
export default socketSlice.reducer;
